import $window from './window';

// eslint-disable-next-line
export const isPageUrlContains = (page) => {
  return !!$window?.location?.href?.includes(page);
};
